import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../assets/styles/ServiceOption.module.css';

const ServiceOption = ({ title, description, path }) => {
  return (
      <Link className={styles.serviceOption} to={path}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
      </Link>
  );
};

export default ServiceOption;